import React, { useState } from "react";
import { sortedStories, fmtDate } from "../../data/impactStories";
import { ArrowRight } from "lucide-react";

const filters = ["All", "Environment", "People", "Governance", "Community", "Safety", "Innovation"];

export default function ActivityFeed({ onOpenStory }) {
  const [filter, setFilter] = useState("All");
  const [count, setCount] = useState(5);
  const list = (filter === "All" ? sortedStories : sortedStories.filter((s) => s.categories.includes(filter))).slice(0, count);

  return (
    <section id="latest" data-testid="ri-activity-feed" className="py-24 lg:py-32 bg-[#0c0c0f] scroll-mt-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4 reveal">
            <div className="lg:sticky lg:top-32">
              <div className="text-[11px] uppercase tracking-[0.3em] text-amber-accent mb-4">Latest Activity</div>
              <h2 className="font-display text-4xl sm:text-5xl font-bold leading-[1.05] mb-6">
                What we've been <span className="text-amber-accent">doing lately.</span>
              </h2>
              <p className="text-white/60 leading-relaxed mb-8 text-sm">
                A running record of Impact Stories, newest first. Filter by what matters to you.
              </p>
              <div className="flex flex-wrap gap-2" data-testid="feed-filters">
                {filters.map((f) => (
                  <button
                    key={f}
                    data-testid={`feed-filter-${f.toLowerCase()}`}
                    onClick={() => { setFilter(f); setCount(5); }}
                    className={`px-3.5 py-1.5 rounded-full text-[11px] uppercase tracking-[0.16em] font-semibold border transition-all duration-300 ${
                      filter === f ? "bg-[#F5D000] text-black border-[#F5D000]" : "text-white/55 border-white/15 hover:border-white/40 hover:text-white"
                    }`}
                  >
                    {f}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="relative pl-6 sm:pl-8 border-l border-white/10 space-y-5" data-testid="feed-timeline">
              {list.map((s, i) => (
                <article key={s.id} className="ri-fade-up relative" style={{ animationDelay: `${(i % 5) * 60}ms` }}>
                  <span className="absolute -left-6 sm:-left-8 top-7 -translate-x-1/2 w-3 h-3 rounded-full bg-[#F5D000] ring-4 ring-[#F5D000]/15" />
                  <button
                    data-testid={`feed-card-${s.id}`}
                    onClick={() => onOpenStory(s)}
                    className="group w-full text-left rounded-2xl bg-[#101014] border border-white/8 hover:border-[#F5D000]/50 transition-all p-4 sm:p-5 flex gap-5 items-center"
                  >
                    <div className="hidden sm:block w-28 h-24 shrink-0 rounded-xl overflow-hidden">
                      <img src={s.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px] uppercase tracking-[0.16em] mb-1.5">
                        <span className="text-white/45">{fmtDate(s.date)}</span>
                        {s.categories.map((c) => <span key={c} className="text-[#F5D000] font-bold">{c}</span>)}
                      </div>
                      <h3 className="font-display text-lg font-bold text-white leading-snug">{s.title}</h3>
                      <p className="mt-1.5 text-sm text-white/60 leading-relaxed line-clamp-2">{s.summary}</p>
                    </div>
                    <ArrowRight className="w-4 h-4 text-white/30 group-hover:text-[#F5D000] group-hover:translate-x-1 transition-all shrink-0" />
                  </button>
                </article>
              ))}
            </div>
            {(filter === "All" ? sortedStories.length : sortedStories.filter((s) => s.categories.includes(filter)).length) > count && (
              <button
                data-testid="feed-load-more"
                onClick={() => setCount((c) => c + 5)}
                className="mt-7 ml-6 sm:ml-8 btn-ghost px-6 py-3 rounded-md text-sm font-semibold"
              >
                Show earlier stories
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
